import { isBeforeDateTime, startOfDateTime } from '@occc-app/lib/date';

export const isFutureDateWithoutTime = (date: Date) => {
  const now = new Date();
  return !isBeforeDateTime(date, startOfDateTime(now, 'day'));
};
